import { forwardRef, useImperativeHandle, useState, useRef } from "react";
import { DatePicker } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const DueDatePicker = forwardRef(
  (
    { onChange, initialValue, readonly, id, name, labelText, show = true },
    ref
  ) => {
    const { i18n } = useTranslation(["CreateTaskModal"]);
    const componentRef = useRef(null);

    const [hasDueDateInfo, setHasDueDateInfo] = useState(readonly);
    const [calculatedDate, setCalculatedDate] =
      useState(null); /* api calculated */
    const [value, setValue] = useState(initialValue); /* user-input */
    const [showComponent, setShowComponent] = useState(show);

    const _setCalculatedDate = (date, overrite) => {
      /*
          overrite: resets the component value per se, and lets the calculation control the date.
          change and no overwrite: ony changes the value if there is none. However, the value is stored for when the user clears the input
       */
      setCalculatedDate(date);
      if (overrite) {
        setValue(null);
        componentRef.current?.setValue(date);
      } else if (!value) {
        componentRef.current?.setValue(date);
      }
    };

    useImperativeHandle(
      ref,
      () => ({
        setCalculatedDate: _setCalculatedDate,
        getComponentRef: () => componentRef.current,
        getValue: () => {
          const date = componentRef.current?.getValue();
          date?.setHours(23);
          date?.setMinutes(59);
          date?.setSeconds(59);
          date?.setMilliseconds(0);

          return date;
        },
        setHasDueDateInfo,
        setShowComponent,
      }),
      [componentRef, value]
    );

    if (!showComponent) return null;
    return (
      <DatePicker
        ref={componentRef}
        value={value ? value : calculatedDate}
        name={name}
        id={id}
        labelText={labelText}
        change={(e) => {
          if (e.isInteracted) {
            setValue(e.value);
            if (!e.value) {
              componentRef.current?.setValue(calculatedDate);
            }
          }
          onChange?.(e);
        }}
        readonly={hasDueDateInfo}
        language={i18n.language}
      />
    );
  }
);
